module.exports = __webpack_public_path__ + "media/131.74f8312c.mp3";